import { Link } from '@tanstack/react-router'
import { Button, Card, CardContent } from '@saas-pages/shared/ui'
import { Helmet } from '@saas-pages/shared/public/seo'
import { useT } from '@/shared/i18n'
import { buildTools } from '@/shared/tools/tools'

const FALLBACK_TOOL_LIMIT = 3

export function NotFoundPage() {
  const t = useT()
  const tools = buildTools(t)
    .filter((tool) => tool.status === 'available')
    .slice(0, FALLBACK_TOOL_LIMIT)

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
        <title>404 - {t.notFound.title} - devdeck.ru</title>
      </Helmet>

      <section className="mx-auto flex min-h-[calc(100vh-11rem)] max-w-5xl flex-col justify-center">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_20rem] lg:items-center">
          <div>
            <div className="mb-4 inline-flex rounded-md border border-primary/25 bg-primary/10 px-2.5 py-1 font-mono text-xs font-medium text-primary shadow-sm">
              {t.notFound.eyebrow}
            </div>
            <h1 className="text-3xl font-bold tracking-normal text-foreground sm:text-5xl">
              {t.notFound.title}
            </h1>
            <p className="mt-4 max-w-2xl text-base leading-7 text-muted-foreground">
              {t.notFound.description}
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <Button asChild>
                <Link to="/">{t.notFound.primaryAction}</Link>
              </Button>
              <Button asChild variant="outline">
                <a href="/#tools">{t.notFound.secondaryAction}</a>
              </Button>
            </div>
          </div>

          <Card className="shadow-sm">
            <CardContent className="p-5">
              <div className="font-mono text-xs font-medium uppercase text-muted-foreground">
                {t.notFound.fallbackTitle}
              </div>
              <div className="mt-4 space-y-3">
                {tools.map((tool) => (
                  <Link
                    key={tool.key}
                    to={tool.path}
                    className="block rounded-md border bg-background px-3 py-3 outline-none transition-colors hover:border-primary/45 hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring"
                  >
                    <div className="flex items-center justify-between gap-3">
                      <span className="font-medium tracking-normal">{tool.title}</span>
                      <span className="font-mono text-xs text-primary" aria-hidden>
                        -&gt;
                      </span>
                    </div>
                    <p className="mt-1 line-clamp-2 text-sm leading-5 text-muted-foreground">
                      {tool.shortDescription}
                    </p>
                  </Link>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </>
  )
}
